import type { FC, PropsWithChildren, ReactNode } from 'react';
import React, { useMemo, useState } from 'react';

import { SuiteHeaderStatusContext } from './context';

interface SuiteHeaderStatusProviderProps {
  readonly children: ReactNode;
}

const SuiteHeaderStatusProvider: FC<PropsWithChildren<SuiteHeaderStatusProviderProps>> = ({ children }) => {
  const [isSuiteHeaderFinishedLoading, setSuiteHeaderFinishedLoading] = useState<boolean>(false);

  const value = useMemo(
    () => ({ isSuiteHeaderFinishedLoading, setSuiteHeaderFinishedLoading }),
    [isSuiteHeaderFinishedLoading, setSuiteHeaderFinishedLoading]
  );

  return <SuiteHeaderStatusContext.Provider value={value}>{children}</SuiteHeaderStatusContext.Provider>;
};

export default SuiteHeaderStatusProvider;
